import { render, staticRenderFns } from "./TbkView.vue?vue&type=template&id=4590be04&scoped=true&lang=pug&"
import script from "./TbkView.vue?vue&type=script&lang=js&"
export * from "./TbkView.vue?vue&type=script&lang=js&"
import style0 from "./TbkView.vue?vue&type=style&index=0&id=4590be04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4590be04",
  null
  
)

component.options.__file = "TbkView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VContainer,
  VDialog,
  VForm,
  VSwitch,
  VTextField,
  VToolbar,
})
